<template>
  <section>
    <team v-for="team in teams" v-bind:key="team.id" :team="team" :can-manage="canManage"></team>
  </section>
</template>

<script>
import Team from './Team'

export default {
  components: {
    Team
  },
  props: {
    teams: {
      type: Array,
      required: true
    },
    canManage: {
      type: Boolean,
      default: false
    }
  }
}
</script>